import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './registerServiceWorker'
import i18n from './i18n'
// import * as firebase from "firebase";
// import VueFirebase from 'vue-firebase'
import UUID from 'vue-uuid'
import VueToast from 'vue-toast-notification'
import 'vue-toast-notification/dist/index.css'
import VueCarousel from 'vue-carousel'
import VueLocalStorage from 'vue-localstorage'
import VModal from 'vue-js-modal'
import { DropdownPlugin } from 'bootstrap-vue'
import VueSelectImage from 'vue-select-image'
import { FormPlugin } from 'bootstrap-vue'
import BootstrapVue from 'bootstrap-vue'
import { AlertPlugin } from 'bootstrap-vue'
import { CardPlugin } from 'bootstrap-vue'
import { FormRadioPlugin } from 'bootstrap-vue'
import { FormInputPlugin } from 'bootstrap-vue'
import { FormCheckboxPlugin } from 'bootstrap-vue'

import ToggleButton from 'vue-js-toggle-button'

import { FormTextareaPlugin } from 'bootstrap-vue'
import VueClipboard from 'vue-clipboard2'
import VueAnalytics from 'vue-analytics'
import VueGtm from 'vue-gtm'
import VueFilter from 'vue-filter'
import VueLazyload from 'vue-lazyload'
import VueLoading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import { CollapsePlugin } from 'bootstrap-vue'
import { AvatarPlugin } from 'bootstrap-vue'
import { ImagePlugin } from 'bootstrap-vue'
import { InputGroupPlugin } from 'bootstrap-vue'
import { TablePlugin } from 'bootstrap-vue'

Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: '/img/error.gif',
  loading: '/img/icons/loading.gif',
  attempt: 3,
  throttleWait: 5000,
})

Vue.use(VueFilter)
Vue.use(VueGtm, {
  // container id
  id: 'GTM-KDCQFDJ',
  // enable track or not (optional)
  enabled: true,
  // display console logs debugs or not (optional)
  debug: false,
})

Vue.use(VueAnalytics, {
  id: ['UA-146833596-1', 'AW-700538278'],
  router,
  autoTracking: {
    pageviewOnLoad: false,
  },
})
Vue.use(VueClipboard)
Vue.use(FormTextareaPlugin)
Vue.use(ToggleButton)
Vue.use(FormCheckboxPlugin)
Vue.use(FormInputPlugin)
Vue.use(FormRadioPlugin)
Vue.use(CardPlugin)
Vue.use(AlertPlugin)
Vue.use(BootstrapVue)
Vue.use(FormPlugin)
Vue.use(CollapsePlugin)
Vue.use(AvatarPlugin)
Vue.use(TablePlugin)
Vue.use(ImagePlugin)
// add stylesheet
require('vue-select-image/dist/vue-select-image.css')

Vue.use(VueSelectImage)
Vue.use(DropdownPlugin)
Vue.use(VModal, {
  dialog: true,
})
Vue.use(VueLocalStorage)
Vue.use(VueCarousel)
Vue.use(UUID)
Vue.use(VueLoading)
Vue.use(InputGroupPlugin)

Vue.prototype.$liff = window.liff
Vue.config.productionTip = false

Vue.use(require('vue-moment'))

Vue.use(UUID)
Vue.use(VueToast, {
  position: 'top',
  duration: 3000,
  dismissible: true,
})

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app')
